
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11068_57367)"}},[_c('path',{attrs:{"d":"M18.332 9.959v5.042a.833.833 0 01-1.653.137c-.325-1.944-3.017-2.637-5.429-2.637H7.5V3.334h3.75c2.412 0 5.104-.692 5.429-2.637a.833.833 0 011.655.137v5.042a2.084 2.084 0 010 4.083h-.001z","fill":"#2C8DFF"}}),_c('path',{attrs:{"d":"M5.833 12.5V3.335h-1.25A4.588 4.588 0 000 7.917 4.588 4.588 0 004.583 12.5h1.25zM7.102 14.167H4.583a6.217 6.217 0 01-2.087-.359l1.809 4.826c.19.521.571.937 1.074 1.171a2.067 2.067 0 001.587.069c.52-.19.937-.572 1.17-1.075a2.062 2.062 0 00.07-1.586L7.1 14.166v.001h.001z","fill":"#176CD8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11068_57367"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    